<template>
  <DialogFull :data="dialogSettings" @close="close">
    <div class="container col-lg-8 col-sm-12">
      <h2>Select users to share this role with</h2>
      <span class="secondary-text mt-2">
        This will allow them to view and comment on the role and associated
        applications, interviews, conversations and offers.
      </span>
      <WorkersSelectionWithBottomItems
        class="mt-3"
        :showValidationErrors="showValidationErrors"
        :workers="formattedWorkers"
        :isLoading="isFetchingSharingUsers"
        @change="emitChange"
        :initialSelectedWorkers="initialSelectedWorkers"
      />
    </div>
    <template v-slot:dialog.action>
      <PrimaryButton @click.native="handleSubmit" :loading="isLoading">
        Save Changes
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import WorkersSelectionWithBottomItems from "@/components/bookings/WorkersSelectionWithBottomItems";
import { createNamespacedHelpers } from "vuex";
import {
  BOOKINGS_NAMESPACE,
  SHARE_BOOKING,
  FETCH_USERS_FOR_SHARING
} from "@/store/modules/bookings/actions";
import {
  GET_USERS_FOR_SHARING,
  IS_FETCHING_SHARING_USERS
} from "@/store/modules/bookings/getters";
import { map, filter } from "lodash";
import { withFullName } from "@/utils/users";

const {
  mapActions: mapBookingActions,
  mapGetters: mapBookingGetters
} = createNamespacedHelpers(BOOKINGS_NAMESPACE);

export default {
  components: {
    WorkersSelectionWithBottomItems,
    DialogFull,
    PrimaryButton
  },
  created() {
    this.fetchUsersForSharing(this.currentBookingId);
  },
  data() {
    return {
      showValidationErrors: false,
      dialogSettings: {
        dialog: true,
        title: "Share Role"
      },
      isLoading: false,
      selectedUsers: []
    };
  },
  computed: {
    ...mapBookingGetters({
      usersForSharing: GET_USERS_FOR_SHARING,
      isFetchingSharingUsers: IS_FETCHING_SHARING_USERS
    }),
    formattedWorkers() {
      return map(this.usersForSharing, withFullName);
    },
    currentBookingId() {
      return this.$route.params.id;
    },
    initialSelectedWorkers() {
      return filter(this.usersForSharing, "isAlreadyShared");
    }
  },
  methods: {
    ...mapBookingActions({
      fetchUsersForSharing: FETCH_USERS_FOR_SHARING,
      shareBooking: SHARE_BOOKING
    }),
    emitChange(users) {
      this.selectedUsers = users;
    },
    async validateForm() {
      this.showValidationErrors = true;
      return this.$refs.shareBooking.validate();
    },
    async handleSubmit() {
      this.isLoading = true;
      await this.shareBooking({
        bookingId: this.currentBookingId,
        data: { users: map(this.selectedUsers, ({ id }) => ({ id })) }
      });
      this.isLoading = false;
      this.close();
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
